import { queryView, type QueryResultLike, type QueryView } from '@krp/client-runtime'

import { ORIGIN_LABELS } from '../../catalog-links/model/selectors'
import type { CommonProduct } from '../../catalog/model/types'
import { actionView } from '../../../shared/views'
import type { MutationResultLike } from '../../../shared/views'
import type { CommonProductEditResult, CommonProductEdited, CommonProductVm, ProductSourcesVm } from './types'

export interface CommonProductVmInput {
  mode: 'create' | 'edit'
  /** Чтение товара; в режиме создания не нужно. */
  result: QueryResultLike<CommonProductEdited> | null
  save: MutationResultLike<CommonProductEditResult> | null
  archive: MutationResultLike<unknown> | null
  /** Строка общего каталога этого товара (там связи с источниками); `undefined` — не найдена или ещё не прочитана. */
  catalogItem: CommonProduct | undefined
  catalogLoaded: boolean
  /** Вид ресурса словами — от реестра форм пакета вида, а не ветвлением здесь. */
  kindTitle: (kind: string) => string
}

const READY: QueryView = { status: 'ready', refreshing: false, error: null }
const NO_SOURCES: ProductSourcesVm = { loaded: true, rows: [], hiddenCount: 0 }

export function sourcesOf(item: CommonProduct | undefined, loaded: boolean, kindTitle: (kind: string) => string): ProductSourcesVm {
  if (item === undefined) return loaded ? NO_SOURCES : { loaded: false, rows: [], hiddenCount: 0 }
  return {
    loaded: true,
    rows: item.identities.map((identity) => ({
      resourceId: identity.resourceId,
      kind: identity.resourceKind,
      name: identity.resourceName,
      kindTitle: kindTitle(identity.resourceKind),
      remoteKey: identity.remoteKey,
      originText: ORIGIN_LABELS[identity.origin] ?? identity.origin,
    })),
    hiddenCount: item.hiddenIdentities,
  }
}

/** Модель окна «Общий товар»: чтение, итоги команд и связи. Черновик в модель не входит — он принадлежит окну. */
export function buildCommonProductVm(input: CommonProductVmInput): CommonProductVm {
  const query = input.result === null ? READY : queryView(input.result, () => false)
  return {
    mode: input.mode,
    query,
    product: input.result?.data ?? null,
    save: actionView(input.save),
    saved:
      input.save?.isSuccess === true && input.save.data !== undefined
        ? { version: input.save.data.product.version, replayed: input.save.data.replayed }
        : null,
    archive: actionView(input.archive),
    sources: input.mode === 'create' ? NO_SOURCES : sourcesOf(input.catalogItem, input.catalogLoaded, input.kindTitle),
  }
}
